// extracted by mini-css-extract-plugin
module.exports = {"link":"entity_infos-module__link--2cRzm"};